import { get } from '../Services/http';
import { catchError } from './Error.action';
import { showLoader, hideLoader } from '../Actions/Loader.action';

export const INVOICES_RECEIVE = 'INVOICES_RECEIVE';
export const INVOICES_ERROR = 'INVOICES_ERROR';

export const receive = (data) => ({
    type: INVOICES_RECEIVE,
    payload: {
        list: data,
    },
});

export const setError = error => ({
    type: INVOICES_ERROR,
    payload: {
        error,
    },
});

export const queryInvoices = (fromDate, toDate, sortByDueDate = false) => (dispatch) => {
    const params = new URLSearchParams({
        fromDate,
        toDate,
        sortByDueDate: sortByDueDate.toString(),
    });

    dispatch(showLoader());
    return get(`api/erp/invoices?${params.toString()}`)
        .then(response => response.json())
        .then((result) => {
            dispatch(receive(result));
            dispatch(hideLoader());
        })
        .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};